import {getUrlVar} from "orxapi.tools.url";
import {urlParametersConfig} from "../../config/form";
import {getLocalStorageItem, setLocalStorageItem} from "../../tools/LocalStorage";
import {BirthdateProps, Pax, PaxProps, ValueLabel} from "../components/BookingPax";

/**
 * Store
 * @class
 */
class Store {
    /**
     * initialState
     */
    public initialState() {
        return this.initPaxInStore();
    }

    /**
     * initial Pax Props in store
     */
    private initPaxInStore() {
        const adultNumber = Number(getUrlVar()[urlParametersConfig.adults]) || Number(getLocalStorageItem(urlParametersConfig.adults)) || 2;
        const childrenNumber = Number(getUrlVar()[urlParametersConfig.children]) || Number(getLocalStorageItem(urlParametersConfig.children)) || 0;

        const childrenBirthdate = {};
        const childrenBirthdateInStore = [];
        if (!getUrlVar()[urlParametersConfig.adults] && !getUrlVar()[urlParametersConfig.children]) {
            this.addPaxNumberParams(adultNumber, childrenNumber);
        }
        this.buildChildrenAge(childrenNumber, childrenBirthdate, childrenBirthdateInStore);
        const pax: Pax = {
            nbAdults : adultNumber,
            nbChildren : childrenNumber,
            children : childrenBirthdate
        };

        const paxProps: PaxProps = {
            "pax" : pax,
            "childrenError" : {},
            "paxError" : ""
        };

        setLocalStorageItem(urlParametersConfig.adults, String(pax.nbAdults));
        setLocalStorageItem(urlParametersConfig.children, String(pax.nbChildren));
        setLocalStorageItem(urlParametersConfig.birthdates, "" + childrenBirthdateInStore);
        return paxProps;
    }

    /**
     * add childNumber and AdultNumber in the url if they are not there.
     * @param adultNumber
     * @param childrenNumber
     * @private
     */
    private addPaxNumberParams(adultNumber: number, childrenNumber: number) {
        const queryParams = new URLSearchParams(window.location.hash);
        queryParams.set(urlParametersConfig.adults, String(adultNumber));
        queryParams.set(urlParametersConfig.children, String(childrenNumber));
        const parameter = decodeURIComponent(queryParams.toString()).replace("#", "");
        history.replaceState(null, null, "#" + parameter);

    }

    /**
     * Get children age in store or url before init state
     */
    private buildChildrenAge(childrenNumber: number, childrenBirthdate: any, childrenBirthdateInStore: any) {
        Array(childrenNumber).fill(1).forEach((value: any, index: number) => {
            let birthDateChildInStore = false;
            let birthDateChild = getUrlVar()[urlParametersConfig.birthdates + "_" + (index + 1)];
            if (!birthDateChild) {
                birthDateChild = getLocalStorageItem(urlParametersConfig.birthdates).split(",")[index];
                birthDateChildInStore = true;
            }
            if (birthDateChild) {
                const birthDateChildAge = birthDateChild.split("/");

                const day: ValueLabel = {
                    value : birthDateChildAge[0],
                    label : birthDateChildAge[0]
                };

                const month: ValueLabel = {
                    value : birthDateChildAge[1],
                    label : birthDateChildAge[1]
                };

                const year: ValueLabel = {
                    value : birthDateChildAge[2],
                    label : birthDateChildAge[2]
                };

                const birthdateIndex: BirthdateProps = {
                    "day" : day,
                    "month" : month,
                    "year" : year
                };

                childrenBirthdate[index] = birthdateIndex;
                childrenBirthdateInStore.push(birthDateChild);
                if (birthDateChildInStore) {
                    const queryParams = new URLSearchParams(window.location.hash);
                    queryParams.set(urlParametersConfig.birthdates  + "_" + (index + 1), childrenBirthdateInStore[index]);
                    const parameter = decodeURIComponent(queryParams.toString()).replace("#", "");
                    history.replaceState(null, null, "#" + parameter);
                }
            }
        });
    }

    /**
     * storeConfig
     */
    public storeConfig() {
        return {
            // listener: state => {sessionStorage.setItem("hookStore", JSON.stringify(state))}, // store state in session storage
            logging: false // process.env.NODE_ENV !== "production"
        };
    }

}

export default Store;
